import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentService } from 'src/app/services/payment.service';
import { SettingsService } from 'src/app/services/settings.service';
import { TelemetryService } from 'src/app/services/telemetry.service';
import { panelID } from 'src/app/settings/settings.constants';
import {
  PencilButtonComponent,
  PencilButtonThemeEnum,
} from 'src/app/standalones/components/pencil-button/pencil-button.component';
import {
  IconTypes,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';

export interface StartTrialConfirmationModalData {
  source: string;
}

@Component({
  selector: 'app-start-trial-confirmation-modal',
  standalone: true,
  imports: [TranslateModule, PencilButtonComponent, PencilIconComponent],
  templateUrl: './start-trial-confirmation-modal.component.html',
  styleUrls: ['./start-trial-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartTrialConfirmationModalComponent {
  protected readonly PencilButtonThemeEnum = PencilButtonThemeEnum;
  protected readonly IconTypes = IconTypes;

  constructor(
    public readonly dialogRef: MatDialogRef<StartTrialConfirmationModalComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public readonly data: StartTrialConfirmationModalData | null,
    private readonly paymentService: PaymentService,
    private readonly settingsService: SettingsService,
    private readonly telemetry: TelemetryService,
  ) {}

  startFreeTrial(): void {
    const source = this.data?.source || 'start_trial_confirmation_modal';
    this.telemetry.logBasicEvent('[Trial Checkout Initiated]', {
      source,
    });
    this.paymentService.startFreeTrial();
    this.close();
  }

  viewAllPlans(): void {
    const source = this.data?.source || 'start_trial_confirmation_modal';
    this.telemetry.logBasicEvent('[Institution Upgrade Payment Settings Opened]', {
      source,
    });
    this.settingsService.showSettingsPanel(panelID.payment);
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
